(function () {
  if (window.productGalleryPageDotsInitialized) return;
  window.productGalleryPageDotsInitialized = true;

  const observedPageDots = new WeakSet();

  function bringDotIntoView(pageDots, dot) {
    window.requestAnimationFrame(function () {
      const pageDotsRect = pageDots.getBoundingClientRect();
      const dotRect = dot.getBoundingClientRect();
      const visibleLeft = pageDotsRect.left + pageDots.clientLeft;
      const visibleRight = visibleLeft + pageDots.clientWidth;
      let scrollAmount = 0;

      if (dotRect.left < visibleLeft) {
        scrollAmount = dotRect.left - visibleLeft;
      } else if (dotRect.right > visibleRight) {
        scrollAmount = dotRect.right - visibleRight;
      }

      if (scrollAmount !== 0) {
        pageDots.scrollTo({
          left: pageDots.scrollLeft + scrollAmount,
          behavior: "smooth",
        });
      }
    });
  }

  function handleSelectedDot(pageDots, dot) {
    if (dot.matches(".dot.is-selected")) {
      bringDotIntoView(pageDots, dot);
    }
  }

  function observePageDots(pageDots) {
    if (observedPageDots.has(pageDots)) return;
    observedPageDots.add(pageDots);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "attributes") {
          handleSelectedDot(pageDots, mutation.target);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return;

          if (node.matches(".dot")) {
            handleSelectedDot(pageDots, node);
          }

          node.querySelectorAll(".dot.is-selected").forEach(function (dot) {
            handleSelectedDot(pageDots, dot);
          });
        });
      });
    });

    observer.observe(pageDots, {
      attributes: true,
      attributeFilter: ["class"],
      childList: true,
      subtree: true,
    });

    const selectedDot = pageDots.querySelector(".dot.is-selected");
    if (selectedDot) bringDotIntoView(pageDots, selectedDot);
  }

  function findPageDots(root) {
    if (root.nodeType !== Node.ELEMENT_NODE && root !== document) return;

    if (root.matches && root.matches(".flickity-page-dots")) {
      observePageDots(root);
    }

    root.querySelectorAll(".flickity-page-dots").forEach(observePageDots);
  }

  findPageDots(document);

  const pageDotsObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(findPageDots);
    });
  });

  pageDotsObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
